import React from "react";
import infoIcon from "../assets/images/info-gray.svg";
import trashIcon from "../assets/images/trash-red.svg";
import pencilIcon from "../assets/images/pencil-blue.svg";

export const ListRowComponent = ({
    cardId,
    headerImageText,
    headerTitle,
    deleteCallback,
    editCallback,
    detailsCallback,
    customActions,
    children
}) => {
    return (
        <div key={cardId} className="bg-white rounded-lg shadow overflow-hidden">
            <div className="p-4">
                <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-4 flex-1">
                        {headerImageText && (
                            <div className="bg-green-100 text-green-700 rounded-full h-10 w-10 flex items-center justify-center text-sm font-bold">
                                {headerImageText}
                            </div>
                        )}
                        
                        <div className="flex-1">
                            <h3 className="text-lg font-medium text-gray-900">{headerTitle}</h3>
                            <div className="mt-1 text-sm text-gray-500">
                                {children}
                            </div>
                        </div>
                    </div>

                    {(detailsCallback || editCallback || deleteCallback || customActions) && (
                        <div className="flex space-x-2 flex-wrap">
                            {detailsCallback && (
                                <button
                                    onClick={() => detailsCallback(cardId)}
                                    className="inline-flex items-center px-3 py-1 border border-gray-300 text-sm leading-5 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                                >
                                    <img src={infoIcon} className="h-4 w-4 mr-1" alt=""/>
                                    Details
                                </button>
                            )}
                            {editCallback && (
                                <button
                                    onClick={() => editCallback(cardId)}
                                    className="inline-flex items-center px-3 py-1 border border-blue-300 text-sm leading-5 font-medium rounded-md text-blue-700 bg-white hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                                >
                                    <img src={pencilIcon} className="h-4 w-4 mr-1" alt=""/>
                                    Edit
                                </button>
                            )}
                            {Array.isArray(customActions) && customActions.map((action, index) => (
                                <button
                                    key={index}
                                    onClick={() => action.callback(cardId)}
                                    className={`inline-flex items-center px-3 py-1 border text-sm leading-5 font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 ${action.className || 'border-gray-300 text-gray-700 bg-white hover:bg-gray-50 focus:ring-gray-500'}`}
                                >
                                    {action.icon && <span className="mr-1">{action.icon}</span>}
                                    {action.label}
                                </button>
                            ))}
                            {deleteCallback && (
                                <button
                                    onClick={() => deleteCallback(cardId)}
                                    className="inline-flex items-center px-3 py-1 border border-red-300 text-sm leading-5 font-medium rounded-md text-red-700 bg-white hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                                >
                                    <img src={trashIcon} className="h-4 w-4 mr-1" alt=""/>
                                    Delete
                                </button>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}